module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/moon-9ed6297355d0fd2a4d4dc1642fb0f550.svg";